import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-primary/20 bg-primary/10 flex items-center gap-2 rounded-md border p-2 text-xs" }
const _hoisted_2 = { class: "font-bold" }
const _hoisted_3 = { class: "mb-2 flex items-center gap-2 text-xs font-bold" }
const _hoisted_4 = { class: "text-xs" }

import { Info } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MissingVouchers',
  props: {
    missingVouchers: {},
    totalVouchers: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(HoverCardRoot), {
    "open-delay": 0,
    "close-delay": 0
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(HoverCardTrigger), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", null, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.missingVouchers) + " / " + _toDisplayString(_ctx.totalVouchers), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('vouchers.missing-text')), 1)
            ]),
            _createVNode(_unref(Info), { class: "text-secondary/50 size-3.5" })
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(HoverCardPortal), null, {
        default: _withCtx(() => [
          _createVNode(_unref(HoverCardContent), {
            class: "animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-[300px] rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all",
            "side-offset": 5
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(Info), { class: "text-secondary size-5" }),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('vouchers.help.title')), 1)
              ]),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('vouchers.help.content')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})